import { Button, Empty } from 'antd';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { NoteMessage } from 'types';
import { isEmpty } from 'lodash';
import { NoteCard } from 'leash/components/notes/NoteCard';
import { DrawerNotes, DrawerStyled, HideBtn } from './Notes.styles';
import { apiNote } from 'utilities/http/api/leash/apiNote';
import { notify } from 'utilities/notifications/notify';
import { NotesFooter } from 'leash/components/notes/notesFooter/NotesFooter';
import { log } from 'utilities/log/log';

interface Props {
  travelPackageId: number;
  leadId: number;
  readOnly?: boolean;
}

export function Notes({ leadId, travelPackageId, readOnly }: Props) {
  const [showDrawer, setShowDrawer] = useState(false);
  const toggleShowAddNotes = () => setShowDrawer(!showDrawer);

  const [notes, setNotes] = useState<NoteMessage[]>([]);
  const [isFetching, setIsFetching] = useState(false);
  useEffect(() => {
    async function fetchNotes() {
      setIsFetching(true);
      try {
        const notesResponse = await apiNote.getNotes(travelPackageId);
        if (!notesResponse.isOk) {
          notify.error("Couldn't fetch travel package notes");
          return;
        }

        setNotes(notesResponse.json.notes);
      } catch (e) {
        log.debug(e);
        notify.error('Error fetching package notes');
      }
      setIsFetching(false);
    }

    fetchNotes();
  }, []);

  const notesRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    notesRef.current?.scrollIntoView({ block: 'end' });
  }, [notes.length]);

  return (
    <>
      <Button
        type="primary"
        ghost
        onClick={toggleShowAddNotes}
        loading={isFetching}
        data-testid="add-notes-btn"
      >
        Notes ({notes.length})
      </Button>
      <DrawerStyled
        data-testid="notes-drawer"
        width={500}
        height={300}
        title={`ID:${leadId} - Notes`}
        placement="right"
        closable
        closeIcon={<HideBtn>Hide</HideBtn>}
        onClose={toggleShowAddNotes}
        visible={showDrawer && !isFetching}
        footer={
          <NotesFooter
            notes={notes}
            setNotes={setNotes}
            setShowDrawer={setShowDrawer}
            travelPackageId={travelPackageId}
            readOnly={readOnly}
          />
        }
      >
        <DrawerNotes ref={notesRef}>
          {isEmpty(notes) ? (
            <Empty description="No notes yet" />
          ) : (
            notes.map((n: NoteMessage) => <NoteCard note={n} key={n.id} />)
          )}
        </DrawerNotes>
      </DrawerStyled>
    </>
  );
}
